import styled from "styled-components/macro";

const DivFixed = styled.div<{ width?: string; height?: string }>`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
`;

export default DivFixed;
